import { ArrayUtils, SortingTypes } from '@cinetixx/cinetixx-booking-ui';

export {};

Array.prototype.sortByKey = function<T>(key: keyof T, sortingType = SortingTypes.ASCEND): T[] {
  return ArrayUtils.sortByKey<T>(this, key, sortingType);
};
